import { render, staticRenderFns } from "./RegisterConfirmation.vue?vue&type=template&id=6fa35fa6&scoped=true"
import script from "./RegisterConfirmation.vue?vue&type=script&lang=js"
export * from "./RegisterConfirmation.vue?vue&type=script&lang=js"
import style0 from "./RegisterConfirmation.vue?vue&type=style&index=0&id=6fa35fa6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fa35fa6",
  null
  
)

export default component.exports